import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { 
  FaLinkedinIn, 
  FaFacebookF, 
  FaInstagram, 
  FaTiktok,
  FaArrowRight 
} from 'react-icons/fa';

// Your existing Sidebar component
export default function Sidebar() {
  const navigate = useNavigate();
  return (
    <aside className="sidebar">
      <div className="follow-section">
        <p className="follow-title">FOLLOW US</p>
        <p className="follow-text">
          By reaching out to connect with us, you're taking the first
          step toward unlocking the full potential of your online
          presence.
        </p>
        <div className="social-icons">
          <a href="https://www.linkedin.com/company/ceylonext/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
          <a href="https://www.facebook.com/share/1UWD6nVTPA/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
          <a href="https://www.instagram.com/ceylonext?igsi=MXU5ZGRkMmdic2ZuMw==&utm_source=ig_contact_invite" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://www.tiktok.com/@ceylonext" target="_blank" rel="noopener noreferrer"><FaTiktok /></a>
        </div>
      </div>
      <div className="sidebar-bottom">
        <button className="transform-button" onClick={() => navigate('/contact')}>
          Let's Transform Your Digital Presence
          <div className="arrow-circle">
            <FaArrowRight />
          </div>
        </button>
        <Link to="/faq" style={{ 
          display: 'block', 
          textAlign: 'center', 
          marginTop: '1.5rem', 
          fontSize: '0.75rem', 
          color: 'var(--text-secondary)',
          textDecoration: 'none',
          opacity: 0.7
        }}>
          FAQ
        </Link>
      </div>
    </aside>
  );
}